export default __webpack_public_path__ + "static/media/chair2.02bbab0f.jpg";